import { render } from "./App.vue?vue&type=template&id=04b3fcca"
import script from "./App.vue?vue&type=script&language=typescript&lang=js"
export * from "./App.vue?vue&type=script&language=typescript&lang=js"

import "./App.vue?vue&type=style&index=0&id=04b3fcca&lang=css"
script.render = render

export default script